import { render, staticRenderFns } from "./FeedbackDetailsModal.vue?vue&type=template&id=2c91e824&scoped=true&"
import script from "./FeedbackDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./FeedbackDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackDetailsModal.vue?vue&type=style&index=0&id=2c91e824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c91e824",
  null
  
)

export default component.exports